import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class MenuContextService extends BehaviorSubject<boolean> {
	constructor() {
		super(true);
	}
}
